import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import HeaderDefault from "../../components/header/HeaderDefault";
import Pricing from "../../components/pricing/Pricing";
import CopyRight from "../../components/footer/copyright/CopyRight";
import Footer from "../../components/footer/Footer";

const PricingInner = () => {
  return (
    <div>
      <Helmet>
        <title>One-Digitalify Datenschutz & AGBs</title>
      </Helmet>
      {/* End Page SEO Content */}

      <HeaderDefault />
      {/* End Header */}

      <div className="ptf-main">
        <div className="ptf-page ptf-page--pricing">
          <section>
            {/* <!--Spacer--> */}
            <div
              className="ptf-spacer"
              style={{ "--ptf-xxl": "10rem", "--ptf-md": "5rem" }}
            ></div>
            <div className="container">
              <div className="row">
                <div className="col-xl-10">
                  {/* <!--Animated Block--> */}
                  <div
                    className="ptf-animated-block"
                    data-aos="fade"
                    data-aos-delay="0"
                  >
                    <h1 className="large-heading">Datenschutz</h1>
                    {/* <!--Spacer--> */}
                    <div
                      className="ptf-spacer"
                      style={{ "--ptf-xxl": "2.5rem" }}
                    ></div>
                    <div>
                       <h1>Datenschutzvereinbarung</h1>
    <h3>1. Einleitung</h3>
    <p>Die One-Digitalify UG (haftungsbeschränkt) („wir“ oder „uns“) nimmt den Schutz Ihrer personenbezogenen Daten sehr ernst. Diese Datenschutzvereinbarung informiert Sie über die Art, den Umfang und den Zweck der Erhebung und Verwendung Ihrer Daten beim Besuch unserer Website sowie bei der Bereitstellung von Hosting-Dienstleistungen.</p>

    <h3>2. Verantwortliche Stelle</h3>
    <p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
    <p>One-Digitalify UG (haftungsbeschränkt)<br/>Im Unteren Feld 59,<br/>73277 Owen, Deutschland<br/>E-Mail: mail@one-digitalify.de</p>

    <h3>3. Erhebung und Verarbeitung personenbezogener Daten</h3>
    <p>Wir erheben und verarbeiten Ihre personenbezogenen Daten nur im Einklang mit den gesetzlichen Vorschriften der DSGVO (Datenschutz-Grundverordnung). Zu den verarbeiteten Daten gehören:</p>
    <ul>
        <li>Kontaktdaten (z. B. Name, E-Mail-Adresse, Telefonnummer)</li>
        <li>Server-Log-Daten (z. B. IP-Adresse, Zeitpunkt des Zugriffs)</li>
        <li>Vertragsdaten bei der Bereitstellung von Hosting-Dienstleistungen (z. B. Kundennummer, Zahlungsinformationen)</li>
    </ul>

    <h3>4. Zweck der Datenverarbeitung</h3>
    <p>Die Erhebung und Verarbeitung Ihrer Daten erfolgt zu folgenden Zwecken:</p>
    <ul>
        <li>Zur Bereitstellung und Funktionalität unserer Website</li>
        <li>Zur Abwicklung von Hosting-Verträgen und technischen Dienstleistungen</li>
        <li>Zur Sicherstellung der IT-Sicherheit und zur Optimierung unserer Online-Angebote</li>
        <li>Zur Kommunikation und Beantwortung von Anfragen</li>
    </ul>

    <h3>5. Weitergabe von Daten</h3>
    <p>Ihre Daten werden grundsätzlich nicht an Dritte weitergegeben, es sei denn:</p>
    <ul>
        <li>dies ist für die Erfüllung des Vertrags erforderlich,</li>
        <li>Sie haben ausdrücklich eingewilligt, oder</li>
        <li>es besteht eine gesetzliche Verpflichtung zur Weitergabe.</li>
    </ul>

    <h3>6. Hosting und technische Dienstleistungen</h3>
    <p>Wir bieten Hosting-Dienstleistungen an und arbeiten mit externen Hosting-Partnern zusammen. Diese Partner erhalten nur die Daten, die für die Erfüllung ihrer Dienstleistungen erforderlich sind. Die Verarbeitung Ihrer Daten erfolgt auf Grundlage eines Auftragsverarbeitungsvertrags gemäß Art. 28 DSGVO.</p>

    <h3>7. Sicherheit</h3>
    <p>Wir setzen technische und organisatorische Maßnahmen ein, um Ihre Daten vor Verlust, Missbrauch und unberechtigtem Zugriff zu schützen. Unsere Sicherheitsmaßnahmen werden kontinuierlich verbessert, um dem Stand der Technik zu entsprechen.</p>

    <h3>8. Rechte der betroffenen Personen</h3>
    <p>Sie haben das Recht:</p>
    <ul>
        <li>Auskunft über die von uns verarbeiteten personenbezogenen Daten zu verlangen,</li>
        <li>die Berichtigung unrichtiger oder unvollständiger Daten zu fordern,</li>
        <li>die Löschung Ihrer Daten zu verlangen, sofern dies nicht durch gesetzliche Aufbewahrungspflichten eingeschränkt ist,</li>
        <li>die Einschränkung der Verarbeitung zu fordern oder Widerspruch gegen die Verarbeitung einzulegen,</li>
        <li>die Übertragung Ihrer Daten an einen anderen Anbieter zu verlangen.</li>
    </ul>

    <h3>9. Kontakt</h3>
    <p>Wenn Sie Fragen zum Datenschutz haben oder Ihre Rechte geltend machen möchten, können Sie uns jederzeit unter den oben genannten Kontaktdaten erreichen.</p>

    <h3>10. Änderungen der Datenschutzvereinbarung</h3>
    <p>Wir behalten uns das Recht vor, diese Datenschutzvereinbarung jederzeit zu ändern, um sie an neue gesetzliche Vorgaben oder technische Änderungen anzupassen. Die jeweils aktuelle Version finden Sie auf unserer Website.</p>

    <h3>One-Digitalify UG (haftungsbeschränkt)</h3>
    <p>Im Unteren Feld 59,<br />73277 Owen, Deutschland</p>

    <h1>Allgemeine Geschäftsbedingungen (AGB)</h1>
    
    <h3>1. Geltungsbereich</h3>
    <p>Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge, die zwischen der One-Digitalify UG (haftungsbeschränkt), Im Unteren Feld 59, 73277 Owen, Deutschland („uns“ oder „wir“), und unseren Kunden über unsere Website oder im Rahmen unserer Dienstleistungen abgeschlossen werden.</p>

    <h3>2. Vertragsabschluss</h3>
    <p>Ein Vertrag zwischen uns und dem Kunden kommt zustande, sobald der Kunde eine Bestellung über unsere Website oder per E-Mail aufgibt und wir diese Bestellung durch eine Bestätigung per E-Mail annehmen.</p>

    <h3>3. Leistungsumfang</h3>
    <p>Wir bieten digitale Dienstleistungen, insbesondere Webhosting, Webdesign und ähnliche Services an. Der genaue Leistungsumfang ergibt sich aus dem jeweiligen Vertrag oder der Angebotsbeschreibung.</p>

    <h3>4. Preise und Zahlungsbedingungen</h3>
    <p>Alle Preise sind Endpreise und enthalten die gesetzliche Mehrwertsteuer. Die Zahlung erfolgt per Überweisung, PayPal oder nach Vereinbarung. Der Kunde verpflichtet sich, die vereinbarte Vergütung fristgerecht zu zahlen.</p>

    <h3>5. Haftung</h3>
    <p>Wir haften für Schäden, die durch Vorsatz oder grobe Fahrlässigkeit verursacht wurden, unbegrenzt. Für leichte Fahrlässigkeit haften wir nur bei Verletzung wesentlicher Vertragspflichten und beschränkt auf den vorhersehbaren Schaden.</p>

    <h3>6. Widerrufsrecht</h3>
    <p>Verbrauchern steht ein gesetzliches Widerrufsrecht zu. Die Widerrufsfrist beträgt 14 Tage ab Vertragsschluss. Zur Ausübung des Widerrufsrechts genügt die rechtzeitige Absendung des Widerrufs an unsere Kontaktadresse.</p>

    <h3>7. Datenschutz</h3>
    <p>Wir verarbeiten personenbezogene Daten unserer Kunden nur im Rahmen der gesetzlichen Vorschriften. Details entnehmen Sie bitte unserer <a href="#datenschutz">Datenschutzvereinbarung</a>.</p>

    <h3>8. Schlussbestimmungen</h3>
    <p>Es gilt das Recht der Bundesrepublik Deutschland. Gerichtsstand für alle Streitigkeiten aus diesem Vertrag ist unser Geschäftssitz in Owen, sofern der Kunde Kaufmann ist. Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt der Vertrag im Übrigen wirksam.</p>

    <h3>One-Digitalify UG (haftungsbeschränkt)</h3>
    <p>Im Unteren Feld 59,<br/>73277 Owen, Deutschland</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!--Spacer--> */}
            <div
              className="ptf-spacer"
              style={{ "--ptf-xxl": "6.25rem", "--ptf-md": "3.125rem" }}
            ></div>
          </section>
          {/* End pricing top section title */}

          <section>
            <div className="container">
              <div
                className="row"
                style={{ "--bs-gutter-x": "2rem", "--bs-gutter-y": "2.5rem" }}
              >
              </div>
              {/* <!--Spacer--> */}
              <div
                className="ptf-spacer"
                style={{ "--ptf-xxl": "6.875rem", "--ptf-md": "3.4375rem" }}
              ></div>
              {/* <!--Animated Block--> */}
              <div
                className="ptf-animated-block"
                data-aos="fade"
                data-aos-delay="0"
              >
                
              </div>
            </div>
            {/* <!--Spacer--> */}
            <div
              className="ptf-spacer"
              style={{ "--ptf-xxl": "10rem", "--ptf-md": "5rem" }}
            ></div>
          </section>
        </div>
      </div>

      {/*=============================================
        Start Footer
        ============================================== */}
      <footer className="ptf-footer ptf-footer--style-1">
        <div className="container-xxl">
          <div className="ptf-footer__top">
            <Footer />
          </div>
          <div className="ptf-footer__bottom">
            <CopyRight />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PricingInner;
